import React, { Component } from 'react'
import { Hero, Loader, Logo } from '../../components/Layout'
import { Table, Button, Alert } from 'antd'
import FileSaver from 'file-saver'
import { bytesToSize } from '../../utils'
import { api } from '../../services'
import mime from 'mime-types'

const isFrench = /^fr\b/.test(window.navigator.language);

const columns = [{
  title: isFrench ? 'Nom' : 'Name',
  dataIndex: 'name',
  width: '50%',
  defaultSortOrder: 'ascend',
  sorter: (a, b) => {
    return a.meta.name.localeCompare(b.meta.name)
  },
  render: (value, record) => record.meta.extension === 'pdf' ? (<a target='_blank' rel='noopener noreferrer' className='viewer-link' href={'/viewer/' + record.token}>{ record.meta.name + '.' + record.meta.extension }</a>) : (<strong>{ record.meta.name + '.' + record.meta.extension }</strong>)
}, {
  title: isFrench ? 'Taille' : 'Size',
  dataIndex: 'size',
  sorter: (a, b) => {
    return a.meta.size - b.meta.size
  },
  render: (value, record) => bytesToSize(record.meta.size)
}]

export default class extends Component {
  state = {
    download: false,
    render: true,
    loading: true,
    error: '',
    data: {
      sharingTokens: []
    },
    keys: [],
    rows: []
  }

  token = null

  componentDidMount () {
    this.token = this.props.match.params.token

    api.share.get(this.token).then((response) => {
      this.setState({
        loading: false,
        data: response.data.result
      })
    }).catch((error) => {
      this.setState({
        render: false,
        error: error.response.data.error.message
      })
    })
  }

  handleRowSelect = (keys, rows) => {
    this.setState({
      keys,
      rows
    })
  }

  handleDownload = () => {
    this.setState({
      download: true
    })

    const promises = this.state.rows.map((selected) => {
      return api.share.download(selected.token).then((response) => {
        const blob = new Blob([response.data], {
          type: mime.contentType(selected.meta.extension) || 'application/octet-stream'
        })

        FileSaver.saveAs(blob, selected.meta.name + '.' + selected.meta.extension)
      })
    })

    Promise.all(promises).then(() => {
      this.setState({
        download: false,
        keys: [],
        rows: []
      })
    })
  }

  render () {
    const { auth, user } = this.props
    const { render, error, loading, keys, download } = this.state
    const tokens = this.state.data.sharingTokens

    const rowSelection = {
      selectedRowKeys: keys,
      onChange: this.handleRowSelect
    }

    if (auth.isAuthenticated && user.info.role === null) {
      return <Loader />
    }

    return (
      <div className='app'>
        <div className='app__wrapper'>
          <div className='header'>
            <div className='header__container'>
              <div className='header__inner'>
                <div className='header__part'>
                  <div className='header__logo' style={{ padding: '.5rem 0 .4rem 0' }}>
                    <Logo width='32' />
                    <div className='header__organization'>Yessspad</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <main className='content share'>
            <div className='app__content'>
              <div className='content__hero'>
                <Hero
                  heading={isFrench ? 'Contenu partagé' : 'Shared content'}
                />
              </div>
              <div className='content__page'>
                <div className='container'>
                  <div className='page'>
                    { render
                      ? <div className='page-share'>
                        <div className='page-content-head page-content-head_desktop page-content__head'>
                          <div className='page-content-head__controls'>
                            <div className='page-content-head__control'>
                              <Button
                                type='indigo'
                                disabled={keys.length === 0 || download}
                                onClick={this.handleDownload}
                                loading={download}
                              >{isFrench ? 'Télécharger' : 'Download'}</Button>
                            </div>
                          </div>
                        </div>
                        <div className='page-content__table'>
                          <Table
                            rowKey={record => record.token}
                            loading={loading}
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={tokens}
                            pagination={false} />
                        </div>
                      </div>
                      : <Alert
                        message={error}
                        type='error'
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Share/Share.jsx